export const mazeConfig = {
  snippetBaseUrl: 'https://snippet.maze.co/maze-universal-loader.js',
  tracingCode: '32d21ea9-6231-41d8-b73e-14a631b1d83b',
  cspDomain: 'https://*.maze.co/',
}
